// Connects to data-controller="native-informations-form-card"

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'nativeZipInput',
    'nativeCountrySelect',
    'nativeZipCodeContainer',
    'nativeCityAutocompleteSelect',
  ];

  static values = {
    countryRequiringZipCode: Array,
  };

  connect() {
    this.onCountryChange();
    window.addEventListener('change.select2', () => {
      this.onCountryChange();
    });
  }

  onAutocompleteResultSelect(event) {
    const { item } = event.detail;

    this.nativeZipInputTarget.value = item?.zip || '';
  }

  onCountryChange() {
    if (
      this.countryRequiringZipCodeValue.includes(
        this.nativeCountrySelectTarget.value
      )
    ) {
      this._dispatchAutocompleteEvent('autocomplete:enter-select');
      this.nativeZipInputTarget.setAttribute('required', 'required');
      this.nativeZipInputTarget.removeAttribute('disabled');
      this.nativeZipInputTarget.classList.remove('disabled');
      this.nativeZipCodeContainerTarget.classList.remove('d-none');
    } else {
      this._dispatchAutocompleteEvent('autocomplete:enter-free');
      this.nativeZipInputTarget.removeAttribute('required');
      this.nativeZipInputTarget.setAttribute('disabled', 'disabled');
      this.nativeZipInputTarget.classList.add('disabled');
      this.nativeZipCodeContainerTarget.classList.add('d-none');
      this.nativeZipInputTarget.value = '';
    }
  }

  _dispatchAutocompleteEvent(eventName) {
    this.nativeCityAutocompleteSelectTarget.dispatchEvent(
      new CustomEvent(eventName, { bubbles: true })
    );
  }
}
